import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { useFlashMessage } from '@indigo-ag/component-module';
import i18next from 'core/i18n';
import { setApprovedConditionals } from 'features/brazil-grower/queries/creditApproval.queries';
import { financingAgFinancing } from 'features/brazil-grower/queries';

interface UseApproveConditionalsParams {
  agFinancingId: string;
  onSuccess?: () => void;
}

export function useApproveConditionals() {
  const { addFlashMessage } = useFlashMessage();
  const [setApprovedConditionalsFn, { loading }] = useMutation(setApprovedConditionals);

  const approveConditionals = useCallback(
    async ({ agFinancingId, onSuccess }: UseApproveConditionalsParams) => {
      try {
        await setApprovedConditionalsFn({
          variables: {
            data: { agFinancingId, approved: true }
          },
          refetchQueries: [
            {
              query: financingAgFinancing,
              variables: { agFinancingId }
            }
          ],
          awaitRefetchQueries: true
        });
        addFlashMessage({
          content: '',
          title: i18next.t('creditConditionalsSuccessfullyApproved'),
          variant: 'success'
        });
        if (onSuccess) {
          onSuccess();
        }
      } catch (error) {
        addFlashMessage({
          content: i18next.t('creditConditionals-errorApproving'),
          title: '',
          variant: 'error'
        });
      }
    },
    [setApprovedConditionalsFn, addFlashMessage]
  );

  return { approveConditionals, loading };
}
